import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import { loadingSections } from '@/lib/loadingSections';
import { LoadingCard } from './LoadingCard';

// Today's loadings in sections with a heading and a count (#117). "Loaded" starts collapsed.
export const LoadingSectionList = ({ loadings, onSelect }) => {
  const [open, setOpen] = useState({});
  const sections = loadingSections(loadings);

  return (
    <div className="space-y-5">
      {sections.map(s => {
        const expanded = open[s.key] ?? !s.collapsed;
        const heading = (
          <>
            <span>{t(`arrivals.section.${s.key}`)}</span>
            <span className="text-muted-foreground font-normal tabular-nums">{s.items.length}</span>
          </>
        );
        return (
          <section key={s.key} className="space-y-2" aria-label={t(`arrivals.section.${s.key}`)}>
            {s.collapsed ? (
              <button
                type="button"
                aria-expanded={expanded}
                onClick={() => setOpen(o => ({ ...o, [s.key]: !expanded }))}
                className="flex items-center gap-2 text-sm font-semibold hover:text-primary"
              >
                {heading}
                <ChevronDown className={cn('h-4 w-4 transition-transform', expanded && 'rotate-180')} aria-hidden="true" />
              </button>
            ) : (
              <h3 className="flex items-center gap-2 text-sm font-semibold">{heading}</h3>
            )}
            {expanded && s.items.map(l => <LoadingCard key={l.id} loading={l} onSelect={onSelect} />)}
          </section>
        );
      })}
    </div>
  );
};
